import React from 'react'
import { Box, Typography, Link, Skeleton } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { Link as RouterLink } from 'react-router-dom'
import { J1RightarrowD } from '@e3dc-react/icons'
import { getLocalizedNumber } from 'src/Libs/languages/functions/default'

const useStyles = makeStyles()(theme => ({
  container: {
    backgroundColor: theme.palette.grey.grey07,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    height: '100%',
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    justifyContent: 'space-around',
  },
  headline: {
    wordBreak: 'break-word',
  },
  textContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(0),
    },
  },
  headlineContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  arrowLink: {
    color: theme.palette.text.primary,
    display: 'flex',
  },
}))

export interface DataCardProps {
  headline: string
  value: string
  subTitle: string | JSX.Element
  className?: string
  link?: string
  dataQa?: string
  isLoading?: boolean
}

/**
 * TODO: Move away from shell since only used by portal?
 *
 * @param param0
 * @returns
 */
const DataCard: React.VFC<DataCardProps> = ({ headline, value, subTitle, className, link, dataQa, isLoading }) => {
  const [valueData, valueUnit] = value.split(' ')
  const { classes, cx } = useStyles()
  const localizedValue = getLocalizedNumber(valueData, 2)
  const localizedValueWithoutDigits = getLocalizedNumber(valueData, 0)
  const valueToDisplay = isNaN(Number(localizedValue)) ? valueData : localizedValue
  const valueWithDynamicDigits = valueData === '0' ? localizedValueWithoutDigits : valueToDisplay

  return (
    <Box className={cx(classes.container, className)} data-qa={dataQa}>
      <Box className={classes.headlineContainer}>
        <Typography variant={'h3'} className={classes.headline}>
          {headline}
        </Typography>
        {link && (
          <Link component={RouterLink} variant="body2" to={link} className={classes.arrowLink}>
            <J1RightarrowD />
          </Link>
        )}
      </Box>
      <Box className={classes.textContainer}>
        {isLoading ? (
          <Box sx={{ display: 'flex', width: '100%', flexDirection: 'column', gap: 0.5 }}>
            <Skeleton variant="text" sx={{ fontSize: '1.2rem' }} />
            <Skeleton variant="text" sx={{ fontSize: '.8rem' }} />
          </Box>
        ) : (
          <>
            <Typography variant={'h1'} sx={{ whiteSpace: 'nowrap' }} data-qa={dataQa ? `${dataQa}-value` : undefined}>
              {valueWithDynamicDigits}
              <Typography variant="h2" component="span">
                {` ${valueUnit ?? ''}`}
              </Typography>
            </Typography>
            {subTitle}
          </>
        )}
      </Box>
    </Box>
  )
}

export default DataCard
